// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_BuscaclienteslistacontatosfidelizacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/buscaClientesListaContatosFidelizacao
 *
 * Returns array of clientes with fidelizacao tracking data.
 */
import type { GestaoClientes_BuscaclienteslistacontatosfidelizacaoRow } from './GestaoClientes_BuscaclienteslistacontatosfidelizacaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_BuscaclienteslistacontatosfidelizacaoResponseDados = GestaoClientes_BuscaclienteslistacontatosfidelizacaoRow[];

export type GestaoClientes_BuscaclienteslistacontatosfidelizacaoResponse = ApiResponse<GestaoClientes_BuscaclienteslistacontatosfidelizacaoResponseDados>;

registerResponseContract('GestaoClientes_BuscaclienteslistacontatosfidelizacaoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:                              { type: 'number',  required: true },
      cliente_nome:                            { type: 'string',  required: true },
      cliente_cpf:                             { type: 'string',  required: false },
      cliente_ddd:                             { type: 'string',  required: false },
      cliente_telefone:                        { type: 'string',  required: false },
      cliente_rua:                             { type: 'string',  required: false },
      cliente_numero:                          { type: 'string',  required: false },
      cliente_complemento:                     { type: 'string',  required: false },
      cliente_bairro:                          { type: 'string',  required: false },
      cliente_cidade_id:                       { type: 'number',  required: false },
      cliente_franquia_id:                     { type: 'number',  required: true },
      cliente_obs:                             { type: 'string',  required: false },
      cliente_location_id:                     { type: 'number',  required: false },
      cliente_location_type:                   { type: 'string',  required: false },
      cliente_link_conversa:                   { type: 'string',  required: false },
      cliente_status:                          { type: 'number',  required: false },
      cliente_data_cadastro:                   { type: 'string',  required: false },
      cliente_origem_id:                       { type: 'number',  required: false },
      cliente_cep:                             { type: 'string',  required: false },
      cliente_ddi:                             { type: 'string',  required: false },
      cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
      cliente_data_ultimo_orcamento:           { type: 'string',  required: false },
      cliente_qtd_compromissos:                { type: 'number',  required: false },
      cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
      cliente_email:                           { type: 'string',  required: false },
      cliente_data_nascimento:                 { type: 'string',  required: false },
      cliente_genero:                          { type: 'string',  required: false },
      cliente_document_type:                   { type: 'string',  required: false },
      cliente_categoria:                       { type: 'string',  required: false },
      cliente_profissao:                       { type: 'string',  required: false },
      whatsapp_device:                         { type: 'string',  required: false },
      whatsapp_device_id:                      { type: 'number',  required: false },
      franquia:                                { type: 'string',  required: false },
      localidade:                              { type: 'string',  required: false },
    },
  },
})
